import type {
  EngagementAccumulatorState,
  EngagementLevel,
  EngagementSummaryData,
} from '../../contracts/engagement';

export type EngagementSummaryInput = {
  readonly state: EngagementAccumulatorState;
  readonly score: number;
  readonly peakScore: number;
  readonly averageScore: number;
  readonly level: EngagementLevel;
  readonly endedAt: number;
};

/**
 * Constrói o payload sanitizado do ENGAGEMENT_SUMMARY.
 * Sem PII, sem DOM, apenas contadores/durações serializáveis.
 */
export class EngagementSummaryBuilder {
  build(input: EngagementSummaryInput): EngagementSummaryData {
    const { state } = input;
    return {
      score: input.score,
      peakScore: input.peakScore,
      averageScore: input.averageScore,
      level: input.level,
      activeDurationMs: state.activeDurationMs,
      idleDurationMs: state.idleDurationMs,
      visibleDurationMs: state.visibleDurationMs,
      hiddenDurationMs: state.hiddenDurationMs,
      maxScrollPercent: state.maxScrollPercent,
      clickCount: state.clickCount,
      rageClickCount: state.rageClickCount,
      viewportEntryCount: state.viewportEntryCount,
      heartbeatCount: state.heartbeatCount,
      startedAt: state.startedAt,
      endedAt: input.endedAt,
    };
  }
}
